export default {
      id: "clock-9-usage",
      viewBox: "0 0 9 9",
      url: __webpack_public_path__ + "sprite-46b249.svg#clock-9-usage",
      toString: function () {
        return this.url;
      }
    }